import {
  agentBillingRouter,
  agentBillingUtils,
} from "@v2/trpc/routes/agentBilling";
import { workspaceUtils } from "@v2/trpc/routes/workspace";

const useAgentApplySubscriptionChangeMutation = () => {
  const {
    mutateAsync: applySubscriptionChange,
    isPending,
    data,
  } = agentBillingRouter.checkout.createUpdateSubscriptionSession.useMutation({
    onSuccess: (data) => {
      void workspaceUtils.getUserWorkspacesList.invalidate();
      void agentBillingUtils.subscription.find.invalidate();
      void agentBillingUtils.subscription.findRateCards.invalidate();
      void workspaceUtils.getPublishedElementsUsage.invalidate();
      void workspaceUtils.getReploSitesUsage.invalidate();
      void workspaceUtils.getShopifyThemeProjectsUsage.invalidate();

      if (
        window &&
        data.success &&
        data.confirmationRequired &&
        data.confirmationUrl
      ) {
        window.location.href = data.confirmationUrl;
      }
    },
  });

  return {
    applySubscriptionChange,
    isLoading: isPending,
    data,
  };
};

export default useAgentApplySubscriptionChangeMutation;
